package com.esoris.kmpmoout.features.product

import androidx.lifecycle.ViewModel
import androidx.lifecycle.viewModelScope
import com.esoris.kmpmoout.domaindata.product.Product
import com.esoris.kmpmoout.domaindata.product.ProductRepository
import com.esoris.kmpmoout.navigation.NavManager
import kotlinx.coroutines.flow.MutableStateFlow
import kotlinx.coroutines.flow.asStateFlow
import kotlinx.coroutines.launch
import kotlin.uuid.ExperimentalUuidApi
import kotlin.uuid.Uuid

class ProductViewModel(
    private val navManager: NavManager,
    private val productRepository: ProductRepository,
) : ViewModel() {

    private val _state = MutableStateFlow(ProductUiState())
    val state = _state.asStateFlow()

    val products = productRepository.getProducts()

    init {
        viewModelScope.launch {
            products.collect { list ->
                _state.value = _state.value.copy(products = list)
            }
        }
    }

    @OptIn(ExperimentalUuidApi::class)
    fun onEvent(event: ProductEvent) {
        when(event) {
            is ProductEvent.OnNavigateTo -> { navManager.navigate(event.route) }
            is ProductEvent.OnNameChange -> _state.value = _state.value.copy(name = event.name)
            is ProductEvent.OnAddProduct -> {
                viewModelScope.launch {
                    productRepository.insertProduct(
                        Product(
                            id = Uuid.random().toString(),
                            name = event.name
                        )
                    )
                }

            }
        }
    }

}